(function () {
  var SWIPE_MIN_DISTANCE = 40;

  function initGallery(root) {
    if (root.dataset.awGalleryInitialized === 'true') return;
    root.dataset.awGalleryInitialized = 'true';

    var main = root.querySelector('[data-aw-gallery-main]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-aw-gallery-thumb]'));
    if (!main || !thumbs.length) return;

    var prev = root.querySelector('[data-aw-gallery-prev]');
    var next = root.querySelector('[data-aw-gallery-next]');
    var counter = root.querySelector('[data-aw-gallery-count]');

    var currentIndex = function () {
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].getAttribute('aria-pressed') === 'true') return i;
      }
      return 0;
    };

    var show = function (index) {
      var thumb = thumbs[index];
      var fullSrc = thumb && thumb.getAttribute('data-full-src');
      if (!fullSrc) return;

      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = fullSrc;

      var fullAlt = thumb.getAttribute('data-full-alt');
      if (fullAlt) main.alt = fullAlt;

      thumbs.forEach(function (candidate) {
        candidate.setAttribute('aria-pressed', String(candidate === thumb));
      });

      if (counter) counter.textContent = (index + 1) + ' / ' + thumbs.length;
    };

    var step = function (direction) {
      var index = (currentIndex() + direction + thumbs.length) % thumbs.length;
      show(index);

      var strip = thumbs[index].parentNode;
      if (strip && strip.scrollWidth > strip.clientWidth) {
        var target = thumbs[index].offsetLeft - (strip.clientWidth - thumbs[index].offsetWidth) / 2;
        strip.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      }
    };

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        show(index);
      });
    });

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    if ((prev || next) && thumbs.length > 1) {
      var startX = 0;
      var startY = 0;
      main.addEventListener('touchstart', function (event) {
        var touch = event.changedTouches[0];
        startX = touch.clientX;
        startY = touch.clientY;
      }, { passive: true });
      main.addEventListener('touchend', function (event) {
        var touch = event.changedTouches[0];
        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;
        if (Math.abs(dx) < SWIPE_MIN_DISTANCE || Math.abs(dx) < Math.abs(dy)) return;
        step(dx < 0 ? 1 : -1);
      }, { passive: true });
    }
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-aw-gallery]'), initGallery);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
